import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#F4811F',
        secondary: '#EE2526',
        success: '#198C19',
        error: '#EE2526',
        warning: '#F4811F',
        info: '#F4811F',
        accent: '#F4811F',
      },
    },
  },
});
